module.exports = __webpack_public_path__ + "img/colaboracionagenciamovilidad.1945bee4.png";